
export interface IMyMillUnitStatus {
    syncedAt: string;
    updatedAt: string;
    lastHash: string;
}

export class MyMillUnitStatus implements IMyMillUnitStatus {
    public syncedAt: string;
    public updatedAt: string;
    public lastHash: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IMyMillUnitStatus);
    constructor(obj?: any) {
        this.syncedAt = obj && obj.syncedAt || '';
        this.updatedAt = obj && obj.updatedAt || '';
        this.lastHash = obj && obj.lastHash || '';

    }
}
